import {
  Badge,
  Box,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogProps,
  Skeleton,
  SkeletonBox,
  Text,
  theme,
} from "@aksara-ui/react";
import LazyLoadImageWithBlurHash from "components/LazyLoadImageWithBlurHash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { getRewardShipmentById } from "redux/actions";

interface Props {
  catalogShipmentId: string;
}

const RewardShipmentDetailsContent: React.FC<Props & DialogProps> = ({
  isOpen,
  onClose,
  catalogShipmentId,
}) => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const { appUrl } = useSelector((state: any) => state.globalReducer);
  const { rewardShipmentUserCatalogs, isRewardShipmentDetailLoading } =
    useSelector((state: any) => state.rewardShipmentReducer);

  const handleCloseModal = () => {
    onClose && onClose();
  };

  useEffect(() => {
    if (isOpen) {
      dispatch(getRewardShipmentById(catalogShipmentId) as any);
    }
  }, [isOpen, dispatch, catalogShipmentId]);

  return (
    <Dialog
      disableOverlayClick
      isOpen={isOpen}
      onClose={() => handleCloseModal()}
      overflowY={"auto"}
    >
      <DialogHeader>
        <Text fontWeight={700}>Reward Shipment Detail</Text>
      </DialogHeader>
      <DialogContent>
        <Box paddingY={20}>
          <Box
            height={isMobile ? "100%" : 150}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            marginBottom={15}
            // width={isCatalogDetailLoading ? 200 : "100%"}
          >
            {isRewardShipmentDetailLoading ? (
              <SkeletonBox style={{ width: 180, height: 130 }} />
            ) : (
              <LazyLoadImageWithBlurHash
                src={`${appUrl}/storage/${
                  rewardShipmentUserCatalogs?.[0]?.catalog_stock?.catalog
                    ?.img_url || ""
                }`}
                alt="catalog-image"
                width={192}
                style={{
                  borderRadius: 20,
                }}
              />
            )}
          </Box>

          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
            style={{ gap: 12 }}
            width={"100%"}
          >
            {isRewardShipmentDetailLoading ? (
              <Skeleton style={{ width: "100%" }} />
            ) : (
              <Text fontWeight={500} color={theme.colors.grey06}>
                Product Information
              </Text>
            )}
            <Box display={"flex"} flexDirection={"column"} style={{ gap: 12 }}>
              {isRewardShipmentDetailLoading ? (
                <Skeleton style={{ height: 50 }} />
              ) : (
                <Text scale={500} fontWeight={700}>
                  {rewardShipmentUserCatalogs?.[0]?.catalog_stock?.catalog
                    ?.catalog_name || ""}
                </Text>
              )}

              {isRewardShipmentDetailLoading ? (
                <Skeleton />
              ) : (
                <Text scale={400} fontWeight={600} color={theme.colors.green06}>
                  Quantity {rewardShipmentUserCatalogs.length}
                </Text>
              )}

              {isRewardShipmentDetailLoading ? (
                <Skeleton style={{ height: 30 }} />
              ) : (
                <Badge
                  size="lg"
                  variant={"info"}
                  paddingY={20}
                  style={{ height: 30, fontSize: 14, fontWeight: 600 }}
                >
                  {rewardShipmentUserCatalogs?.[0]?.catalog_stock?.catalog
                    ? rewardShipmentUserCatalogs[0].catalog_stock.catalog
                        .is_voucher
                      ? "Digital Goods"
                      : "Physical Goods"
                    : ""}
                </Badge>
              )}
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RewardShipmentDetailsContent;
